import type { ReactNode } from 'react';

interface Props {
  span: 'full' | '6' | '4' | '3' | '2';
  title: string;
  subtitle?: string;
  presPill?: string;
  sourceCount?: number;
  refinedTag?: string;
  highlighted?: boolean;
  loading?: boolean;
  children: ReactNode;
}

export function Tile({
  span, title, subtitle, presPill, sourceCount, refinedTag, highlighted, loading, children,
}: Props) {
  return (
    <div className={`dash-tile dash-tile--span-${span} ${highlighted ? 'dash-tile--highlighted' : ''}`}>
      <div className="dash-tile__head">
        <div className="dash-tile__head-left">
          <span className="dash-tile__title">{title}</span>
          {subtitle && <span className="dash-tile__subtitle">{subtitle}</span>}
        </div>
        <div className="dash-tile__head-right">
          {refinedTag && <span className="dash-tile__refined-tag">↳ {refinedTag}</span>}
          {presPill && <span className="dash-tile__pres-pill">{presPill}</span>}
          {sourceCount !== undefined && sourceCount > 0 && (
            <span className="dash-tile__src-count">📑 {sourceCount}</span>
          )}
          <button className="dash-tile__btn" aria-label="More actions" title="More actions">⋯</button>
        </div>
      </div>
      <div className={`dash-tile__body ${loading ? 'dash-tile__body--loading' : ''}`}>{children}</div>
    </div>
  );
}
